var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{staticClass:"hide-arrows",attrs:{"type":"number","label":_vm.label,"clearable":_vm.clearable,"disabled":_vm.disabled},on:{"keydown":function($event){return _vm.filterKey($event)}},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }